import { stringify } from 'query-string';
import type { User } from '@atlassian/jira-common-directory-v2/src/model';
import type { User as RestUser } from '@atlassian/jira-shared-types';
import { DELETE_STATUS, ARCHIVE_STATUS } from '../../common/constants';
import type {
	ArchivedProperties,
	DeletedProperties,
	PageRequest,
	ProjectApiResponse,
	ProjectTransformed,
	Status,
} from '../../common/types';
import { transformProject } from '../transformers';
import type { Projects, RestApiResponse, GetAdditionalStatusData } from './types';

export const getProjectsListUrl = (baseUrl: string, request: PageRequest): string =>
	`/rest/api/2/project/search?${stringify(request)}`;

export const transformUser = (user: RestUser): User => ({
	displayName: user.displayName,
	avatarUrl: user.avatarUrls && user.avatarUrls['48x48'],
	profileUrl: `/jira/people/${user.accountId}`,
	accountId: user.accountId,
});

export const getAdditionalStatusData: GetAdditionalStatusData = (
	project,
	status,
	baseUrl,
): ArchivedProperties | DeletedProperties => {
	if (status === DELETE_STATUS) {
		return {
			// @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
			deletedDate: project.deletedDate,
			// @ts-expect-error - TS2322 - Type 'User | undefined' is not assignable to type 'User'. | TS2554 - Expected 1 arguments, but got 2.
			deletedBy: project.deletedBy && transformUser(project.deletedBy, baseUrl),
			// @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
			retentionTillDate: project.retentionTillDate,
		};
	}
	if (status === ARCHIVE_STATUS) {
		return {
			// @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
			archivedDate: project.archivedDate,
			// @ts-expect-error - TS2322 - Type 'User | undefined' is not assignable to type 'User'. | TS2554 - Expected 1 arguments, but got 2.
			archivedBy: project.archivedBy && transformUser(project.archivedBy, baseUrl),
		};
	}
	// @ts-expect-error - TS2322 - Type '{}' is not assignable to type 'ArchivedProperties | DeletedProperties'.
	return {};
};

export const transformProjects = (
	data: RestApiResponse,
	baseUrl: string,
	status: Status,
): Projects => {
	if (data) {
		const page: ReadonlyArray<ProjectTransformed> = data.values.map(
			(response: ProjectApiResponse) =>
				// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
				({
					...transformProject(response, baseUrl),
					...getAdditionalStatusData(response, status, baseUrl),
				}) as ProjectTransformed,
		);

		return {
			page,
			total: data.total,
		};
	}
	return {
		page: [],
		total: 0,
	};
};
